import React from "react";
import Image from "next/image";
import { ossFullUrl } from "@/utils/getFullWebCdnUrl";

interface EmptyContainerProps {
	title: string;
	subTitle?: string;
	style?: React.CSSProperties | undefined;
	textStyle?: React.CSSProperties | undefined;
	btnNode?: React.ReactNode;
	iconNode?: React.ReactNode;
}

export default function EmptyContainerV2({
	title,
	subTitle,
	style,
	textStyle,
	btnNode,
	iconNode,
}: EmptyContainerProps) {
	return (
		<div className="flex flex-col items-center justify-center">
			<div className="relative m-auto mt-[88px]" style={style}>
				{iconNode ? (
					iconNode
				) : (
					<>
						<Image
							src={ossFullUrl("/common/content-empty-v2-light.png")}
							width={116}
							height={140}
							alt="empty"
							className="inline-block dark:hidden"
						/>
						<Image
							src={ossFullUrl("/common/content-empty-v2-dark.png")}
							width={116}
							height={140}
							alt="empty"
							className="hidden dark:inline-block"
						/>
					</>
				)}
			</div>
			<div className="pt-2.5 font-semibold" style={{ ...textStyle }}>
				{title}
			</div>
			<div className="pt-2.5 text-xs inter-text" style={{ ...textStyle }}>
				{subTitle}
			</div>
			<div className="text-center">{btnNode}</div>
		</div>
	);
}
